import ExpenseGroupViewer from './components/expense_group';
import ContractViewer from './components/contract';
import OutsourceContractViewer from './components/outsource_contract';
import StockInOrderViewer from './components/stock_in_order';
import StockViewer from './components/stock';
import StockCalculatorViewer from './components/stock_calculator';
import WikiViewer from './components/wiki';
import InvoiceViewer from './components/invoice';
import RecruitNeedViewer from './components/recruit_need';
import RecAwardTopicViewer from './components/rec_award_topic';
import BankStatementRelations from './components/bank_statement_relations';
import ReceipDocumentRelations from './components/receip_document_relations'
import ReceiptBillDetail from './components/receipt_bill_detail'
import MallOnlineItem from './components/mall_online_item';
import OfflineOrderDetail from './components/offline_order_detail';
import OfflineOrderBatchRecordDetail from './components/offline_order_batch_record_detail'
import TransportDetail from './components/transport_detail'
import AbnormalBillDetail from './components/abnormal_bill_detail.jsx'
export default {
  props: {
    model_id: {
      type: Number
    },
    type: {
      type: String
    },
    receipt_type: {
      type: String
    },
    close: {
      type: Function
    },
    viewerParams: {
      type: Object
    }
  },
  functional: true,
  render: (h, context) => {
    let component;
    switch (context.props.type) {
      case 'ExpenseGroup':
        component = ExpenseGroupViewer;
        break;
      case 'Contract':
        component = ContractViewer;
        break;
      case 'OutsourceContract':
        component = OutsourceContractViewer;
        break;
      case 'StockInOrder':
        component = StockInOrderViewer;
        break;
      case 'Stock':
        component = StockViewer;
        break;
      case 'StockCalculator':
        component = StockCalculatorViewer;
        break;
      case 'Wiki':
        component = WikiViewer;
        break;
      case 'Invoice':
        component = InvoiceViewer;
        break;
      case 'RecruitNeed':
        component = RecruitNeedViewer;
        break;
      case 'RecAwardTopic':
        component = RecAwardTopicViewer;
        break;
      case 'MallOnlineItem':
        component = MallOnlineItem;
        break;
      case 'OfflineOrderDetail':
        component = OfflineOrderDetail;
        break;
      case 'OfflineOrderBatchRecordDetail':
        component = OfflineOrderBatchRecordDetail;
        break;
      case 'TransportDetail':
        component = TransportDetail;
        break;
      case 'BankStatementRelations':
        component = BankStatementRelations;
        break;
      case 'ReceiptDocumentRelations':
        component = ReceipDocumentRelations;
        break;
      case 'ReceiptBillDetail': // 收款单
      component = ReceiptBillDetail;
        break;
      case 'AbnormalBillDetail':
        component = AbnormalBillDetail
        break
      default:
        component = '';
    }
    if (component) {
      return h(component, {
        props: {
          model_id: context.props.model_id,
          receipt_type: context.props.receipt_type,
          close: context.props.close,
          viewerParams: context.props.viewerParams
        }
      })
    } else {
      return h('div', {
        'class': {
          'color-error': true,
          'text-large': true,
          'text-center': true
        }
      }, `未设置页面(${context.props.type})`);
    }
  }
}
